import React, { useMemo } from 'react'
import { compareVersions } from 'k8s/util/helpers'
import CheckboxField from 'core/components/validatedForm/CheckboxField'
import { kubernetesDashboardInfo } from 'app/plugins/infrastructure/components/clusters/constants'
import ToggleSwitchField from 'core/components/validatedForm/ToggleSwitchField'
import { topMiddle } from 'core/elements/menu/defaults'

export const kubernetesDashboardFieldId = 'enableKubernetesDashboard'

const KubernetesDashboard = ({ wizardContext, setWizardContext, useToggleSwitch = false }) => {
  const isNewK8sVersion = useMemo(() => {
    const version = wizardContext.kubeRoleVersion || wizardContext.version
    if (!version) {
      return false
    }
    return compareVersions(version, '1.20') >= 0
  }, [wizardContext.kubeRoleVersion, wizardContext.version])

  return (
    <>
      {isNewK8sVersion ? (
        useToggleSwitch ? (
          <ToggleSwitchField
            id={kubernetesDashboardFieldId}
            label="Kubernetes Dashboard"
            onChange={(value) => setWizardContext({ [kubernetesDashboardFieldId]: value })}
            info={kubernetesDashboardInfo}
            infoPlacement={{ align: topMiddle.align, offset: topMiddle.offset }}
          />
        ) : (
          <CheckboxField
            id={kubernetesDashboardFieldId}
            label="Kubernetes Dashboard"
            info={kubernetesDashboardInfo}
            value={wizardContext[kubernetesDashboardFieldId]}
            onChange={(value) => setWizardContext({ [kubernetesDashboardFieldId]: value })}
          />
        )
      ) : null}
    </>
  )
}

export default KubernetesDashboard
